import type { PlayerReport } from '../../../api/playerReports'
const date = (value: string | null) =>
  value ? new Date(value).toLocaleDateString('es-AR') : 'Sin fecha'
const num = (value: number) =>
  value.toLocaleString('es-AR', { maximumFractionDigits: 2 })
export function QuestionnaireScores({
  questionnaires,
}: {
  questionnaires: PlayerReport['questionnaires']
}) {
  if (!questionnaires.length)
    return (
      <p className="report-caption">
        Todavía no hay cuestionarios en tu historial.
      </p>
    )
  return (
    <div className="report-questionnaire-results">
      {[...questionnaires].reverse().map((q, i) => (
        <article className="report-panel" key={`${q.code}-${i}`}>
          <div className="report-section-heading">
            <div>
              <h3>{q.code}</h3>
              <p className="report-caption">
                {q.timepoint} · {date(q.date)}
              </p>
            </div>
            <span className="report-result">{q.status}</span>
          </div>
          {q.reading ? (
            <>
              <div className="report-score-list">
                {q.reading.dimensions.map((d) => (
                  <div className="report-score" key={d.key}>
                    <div>
                      <strong>{d.label}</strong>
                    </div>
                    <div
                      className="report-score-axis"
                      aria-label={`${d.label}: promedio ${num(d.mean)} de 4`}
                    >
                      <span
                        className="report-score-marker"
                        style={{ left: `${((d.mean - 1) / 3) * 100}%` }}
                      />
                      <span>1</span>
                      <span>2</span>
                      <span>3</span>
                      <span>4</span>
                    </div>
                    <p>
                      <strong>{num(d.mean)}/4</strong> promedio · {d.raw} puntos
                      (rango {d.min}–{d.max})
                    </p>
                  </div>
                ))}
              </div>
              {q.reading.total && (
                <p className="report-score-total">
                  <strong>
                    {q.reading.total.label}: {q.reading.total.raw}
                  </strong>{' '}
                  puntos · rango {q.reading.total.min}–{q.reading.total.max}.
                  Mayor puntaje, más recursos declarados.
                </p>
              )}
              <p className="report-caption">
                {q.reading.version} · {q.reading.note}
              </p>
            </>
          ) : q.status === 'Completado' &&
            ['CSAI-2R', 'SMTQ'].includes(q.code) ? (
            <p className="report-caption">
              No hay respuestas completas compatibles con la versión actual para
              corregir esta toma. No se estima un puntaje.
            </p>
          ) : null}
        </article>
      ))}
    </div>
  )
}
